/**
 * Sync Shopify presentment currency with visitor country (Markets).
 *
 * Rules:
 * - Country = Shopify /browsing_context_suggestions.json only (not WebSense wscc_user)
 * - Currency = wscc_markets entry for that country (reflects Shopify Markets config)
 * - USD is forced only for countries in market "us-asie" (US + Asie)
 *
 * Perf (v5): defer redirect until after load/idle so LCP is not blocked by a full reload.
 */
(function () {
  var STORAGE_KEY = "pmcline_market_sync_v5";
  var MAX_POLLS = 60;
  var POLL_MS = 120;
  var DEFER_MS = 8000;

  function activeCurrency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || "";
  }

  function shopifyDetectedCountry(data) {
    return (
      data &&
      data.detected_values &&
      data.detected_values.country &&
      data.detected_values.country.handle
    );
  }

  function lookupWsccMarket(country) {
    country = String(country || "").toUpperCase();
    if (!country || !Array.isArray(window.wscc_markets)) return null;
    for (var i = 0; i < wscc_markets.length; i++) {
      var row = wscc_markets[i];
      if (String(row.country_code || "").toUpperCase() === country) return row;
    }
    return null;
  }

  function currencyForMarketEntry(entry) {
    if (!entry) return "";
    var code = String(entry.currency_code || "").toUpperCase();
    var market = String(entry.marketName || "").toLowerCase();
    if (!code) return "";
    if (code === "USD" && market !== "us-asie") return "";
    return code;
  }

  function currencyForCountry(country) {
    return currencyForMarketEntry(lookupWsccMarket(country));
  }

  function sync(country, want) {
    var active = activeCurrency();
    if (!country || !want || !active || active === want) return false;

    var stamp = country + ":" + want + ":" + active;
    try {
      if (sessionStorage.getItem(STORAGE_KEY) === stamp) return false;
      sessionStorage.setItem(STORAGE_KEY, stamp);
    } catch (e) {}

    var url = new URL(window.location.href);
    if (
      url.searchParams.get("currency") === want &&
      url.searchParams.get("country") === country
    ) {
      return false;
    }
    // Perf: avoid full-page reload (kills LCP / Lighthouse ~8s).
    // Shopify Markets + selectors already handle currency; keep URL clean.
    // If a hard sync is ever needed again, restore location.replace here.
    try {
      sessionStorage.setItem(STORAGE_KEY, stamp + ":skipped-redirect");
    } catch (e2) {}
    return false;
  }

  function attemptWithCountry(country) {
    country = String(country || "").toUpperCase();
    if (!country) return false;
    var want = currencyForCountry(country);
    if (!want) return false;
    return sync(country, want);
  }

  function waitForMarketsThenAttempt(country, onDone) {
    var polls = 0;
    function tick() {
      if (attemptWithCountry(country)) {
        if (onDone) onDone(true);
        return;
      }
      polls += 1;
      var mapped = !!currencyForCountry(country);
      if (mapped || polls >= MAX_POLLS) {
        if (onDone) onDone(false);
        return;
      }
      setTimeout(tick, POLL_MS);
    }
    tick();
  }

  function runSync() {
    fetch("/browsing_context_suggestions.json", { credentials: "same-origin" })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        var country = shopifyDetectedCountry(data);
        if (!country) return;
        waitForMarketsThenAttempt(String(country).toUpperCase());
      })
      .catch(function () {});
  }

  function isAutomationOrBot() {
    try {
      if (navigator.webdriver) return true;
    } catch (e) {}
    var ua = "";
    try {
      ua = String(navigator.userAgent || "");
    } catch (e2) {}
    return /bot|crawl|spider|slurp|lighthouse|pagespeed|chrome-lighthouse|gtmetrix|pingdom|yandex|bingpreview/i.test(
      ua
    );
  }

  function schedule() {
    // Never force a full reload for Lighthouse / crawlers (huge LCP penalty).
    if (isAutomationOrBot()) return;

    // Skip defer if URL already has market params (return visit / deep link)
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.get("country") && u.searchParams.get("currency")) {
        runSync();
        return;
      }
    } catch (e) {}

    var started = false;
    function start() {
      if (started) return;
      started = true;
      runSync();
    }

    if ("requestIdleCallback" in window) {
      requestIdleCallback(start, { timeout: DEFER_MS });
    } else {
      setTimeout(start, DEFER_MS);
    }
    window.addEventListener("load", function () {
      setTimeout(start, Math.min(DEFER_MS, 3000));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", schedule);
  } else {
    schedule();
  }
})();
